interface Props {
  title: string
  description: string
}

const BlogHeader = ({ title, description }: Props) => {
  return (
    <div className='mx-auto max-w-screen-sm text-center lg:mb-16 mb-8'>
      <h2 className='mb-4 text-3xl lg:text-4xl tracking-tight font-extrabold text-white'>{title}</h2>
      <p className='font-light text-gray-300 sm:text-xl'>{description}</p>
    </div>
  )
}

export default BlogHeader
